import React from 'react';
import { ProspectiveCustomerStore, ProspectiveCustomerActions } from '../../utils/ols-core';
import { UX2 } from '@wsb/guac-widget-core';
import PropTypes from 'prop-types';
import Modal from '../shared/Modal';
import { assign } from 'lodash';
import { mapContextToProps } from '../OlsShopContext';

const emailInputStyle = {
  border: 'none',
  borderBottomWidth: 'xsmall',
  borderBottomStyle: 'solid',
  width: '100%',
  fontSize: 'small'
};

const notice = {
  fontSize: 'xsmall',
  textAlign: 'left',
  paddingTop: 'xsmall'
};

const errorMessage = {
  fontSize: 'xsmall',
  color: 'error',
  paddingTop: 'xsmall',
  paddingBottom: 'xxsmall',
  textAlign: 'left'
};

const inputContainerStyle = {
  paddingLeft: 'large',
  paddingRight: 'large'
};

const textBlockStyle = {
  margin: 'large'
};

const loaderStyle = {
  marginTop: '0px',
  marginBottom: '0px'
};

const submitButtonStyle = {
  marginTop: 'small',
  marginBottom: 'small'
};

const SubmitButton = ({ fetching, buttonLabel }) => {
  if (fetching) {
    return (
      <UX2.Element.Block>
        <UX2.Element.Loader style={ loaderStyle } fontSize='large' />
      </UX2.Element.Block>
    );
  }

  return (
    <UX2.Element.Button.Primary
      size='small'
      type='submit'
      style={ submitButtonStyle }
      children={ buttonLabel }
    />
  );
};

SubmitButton.propTypes = {
  fetching: PropTypes.bool,
  buttonLabel: PropTypes.string
};

export class ModalWithEmail extends React.Component {
  constructor() {
    super(...arguments);

    this.state = assign(this.getStoreState());
  }

  getStoreState = () => {
    const { fetching, fetched, email, genericError, invalidEmailError } =
      ProspectiveCustomerStore.getState();

    return {
      fetching,
      fetched,
      email,
      genericError,
      invalidEmailError
    };
  };

  UNSAFE_componentWillMount() {
    ProspectiveCustomerStore.addListener('change', this.onStoreChange);
  }

  onStoreChange = () => {
    this.setState(this.getStoreState());
  };

  handleChange = event => {
    ProspectiveCustomerStore.setState({
      email: event.target.value,
      genericError: null,
      invalidEmailError: null
    });
  };

  handleSubmit = event => {
    event.preventDefault();

    ProspectiveCustomerActions.subscribeToOpenStore(this.state.email);
  };

  get feedback() {
    const { Text, Block } = UX2.Element;
    const { genericError, invalidEmailError } = this.state;
    const translate = this.props.translate;
    let msg = null;

    if (genericError) {
      msg = translate('coming_soon_modal.error');
    } else if (invalidEmailError) {
      msg = translate('coming_soon_modal.emailError');
    } else {
      return null;
    }

    return (
      <Block>
        <Text style={ errorMessage }>{ msg }</Text>
      </Block>
    );
  }

  get content() {
    const { Text, DisplayHeading, Input, Block } = UX2.Element;
    const { Form } = UX2.Group;
    const translate = this.props.translate;

    const title = translate('coming_soon_modal.title');
    const line_1 = translate('coming_soon_modal.content.line_1');
    const line_2 = translate('coming_soon_modal.content.line_2');
    const emailPlaceholder = translate('coming_soon_modal.email_placeholder');
    const emailNotice = translate('coming_soon_modal.email_notice');
    const buttonLabel = translate('coming_soon_modal.cta');
    const { fetching } = this.state;

    return (
      <React.Fragment>
        <DisplayHeading>{ title }</DisplayHeading>
        <Block style={ textBlockStyle }>
          <Text children={ line_1 } />
          <Text children={ line_2 } />
        </Block>

        <Form action='#' onSubmit={ this.handleSubmit }>
          <Block style={ inputContainerStyle }>
            <Input.FloatLabel
              type='text'
              value={ this.state.email }
              onChange={ this.handleChange }
              placeholder={ emailPlaceholder }
              style={ emailInputStyle }
              disabled={ fetching }
            />
            { this.feedback }
            <Text style={ notice }>{ emailNotice }</Text>
          </Block>

          <SubmitButton fetching={ fetching } buttonLabel={ buttonLabel } />
        </Form>
      </React.Fragment>
    );
  }

  render() {
    return (
      <Modal
        renderMode={ this.props.renderMode }
        closeModal={ this.props.closeModal }
        closeOnClickOutside={ true }
      >
        { this.content }
      </Modal>
    );
  }
}

ModalWithEmail.propTypes = {
  renderMode: PropTypes.string,
  closeModal: PropTypes.func,
  translate: PropTypes.func
};

ModalWithEmail.defaultProps = {
  translate: () => {}
};

export default mapContextToProps(ModalWithEmail, context => ({
  translate: context.translate
}));
